import React, { useState } from "react";
import { getIcons } from "../../Constant/Constant";
import SpinWheelService from "../../Services/SpinWheelService";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import Modal from "react-modal";
import { useNavigate } from "react-router-dom";
import { CopyToClipboard } from "react-copy-to-clipboard";


const SpinWheelDetail = ({spinWheelData}) => {
  const [copied, setCopied] = useState(false);
  const [isPauseWheelModal, setIsPauseWheelModal]=useState(false);
  const [isResetWheelModal, setIsResetWheelModal]=useState(false)

  const baseUrl = "https://nfbdgrouprewards.com/spinWheel"
  const textToCopy = baseUrl+"/"+spinWheelData.id
  const icon = getIcons();
  const navigate = useNavigate();
  const handleCopy = async () => {
    setCopied(true);
    setTimeout(() => setCopied(false), 5000)
    // try {
    //  const textCopied= await navigator.clipboard.writeText(textToCopy);
    //   setCopied(true);
    //   setTimeout(() => setCopied(false), 5000)
    //   console.log(`Copied text: "${textToCopy}"`)
    //     } catch (err) {
    //     console.error("Failed to copy text: ", err);
    // }
  };



const handleSpinWheelWonExcel = async () => {
  try {
    const response = await SpinWheelService.getSpinWheelWonExcelList(spinWheelData.id);

    // Extract the resultArray from the response
    const resultArray = response.data.resultArray;

    // Create a new workbook and worksheet
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Winners");

    // Define columns for the worksheet
    worksheet.columns = [
      { header: "Name", key: "Name", width: 20 },
      { header: "Country Code", key: "Country Code", width: 15 },
      { header: "Phone Number", key: "Phone Number", width: 15 },
      { header: "Email ID", key: "Email ID", width: 25 },
      { header: "Type", key: "Type", width: 10 },
      { header: "Price", key: "Price", width: 15 },
      { header: "Spin Timestamp", key: "Spin Timestamp", width: 20 },
      { header: "Gift Expiry Timestamp", key: "Gift Expiry Timestamp", width: 20 },
      { header: "QR UID", key: "QR UID", width: 15 },
    ];

     // Apply header styling
     worksheet.getRow(1).eachCell((cell) => {
      cell.font = { bold: true, color: { argb: "FFFFFFFF" } }; // White text
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FF000000" }, // Black background
      };
      cell.alignment = { vertical: "middle", horizontal: "center" }; // Center alignment
    });
    // Add rows to the worksheet
    resultArray.forEach((row) => {
      worksheet.addRow(row);
    });

    // Generate Excel file and save
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
    saveAs(blob, `SpinWheelWinners_${spinWheelData.id}.xlsx`);

    console.log("Excel file generated successfully!");
  } catch (error) {
    console.error("Error downloading Excel file:", error.response?.data || error.message);
  }
};





const handleSpinWheelLostExcel = async () => {
  try {
    const response = await SpinWheelService.getSpinWheelLostExcelList(spinWheelData.id);

    // Extract the resultArray from the response
    const resultArray = response.data;

    // Define the required keys and default values
    const requiredKeys = ["Name", "Country Code", "Phone Number", "Email ID", "Type", "Spin Timestamp"];

    // Ensure all rows have the required keys
    const formattedData = resultArray.map((row) => {
      const formattedRow = {};
      requiredKeys.forEach((key) => {
        formattedRow[key] = row[key] || ""; // Assign the value or an empty string if missing
      });
      return formattedRow;
    });

    // Create a new workbook and worksheet
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Lost Spins");

    // Define columns for the worksheet
    worksheet.columns = requiredKeys.map((key) => ({
      header: key,
      key,
      width: 20, // Default column width
    }));

    // Apply header styling
    worksheet.getRow(1).eachCell((cell) => {
      cell.font = { bold: true, color: { argb: "FFFFFFFF" } }; // White text
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FF000000" }, // Black background
      };
      cell.alignment = { vertical: "middle", horizontal: "center" }; // Center alignment
    });

    // Add rows to the worksheet
    formattedData.forEach((row) => {
      worksheet.addRow(row);
    });

    // Generate Excel file and save
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
    saveAs(blob, `SpinWheelLost_${spinWheelData.id}.xlsx`);

    console.log("Excel file generated successfully!");
  } catch (error) {
    console.error("Error downloading Excel file:", error.response?.data || error.message);
  }
};

  // Custom styles for Modal
  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      width: "35%",
      padding: "20px",
      position: "relative",
    },
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.75)",
    },
  };
Modal.setAppElement("#root");

const handleWheelReset=()=>{
setIsResetWheelModal(true)
}
const handleCloseResetWheelModal =()=>{
setIsResetWheelModal(false)

}

const handleResetSpinWheelModal =async()=>{
  const resetObj={
    docId:spinWheelData.id
  }
  try{
    const response =await SpinWheelService.resetSpinWheel(resetObj);
    console.log(response.data)
    setIsResetWheelModal(false);
    window.location.reload()
  }catch(error){
    console.log(error.response.data)
  }
}
const handleWheelPause=()=>{
  setIsPauseWheelModal(true);
}
const handleClosePauseWheelModal =()=>{
  setIsPauseWheelModal(false)
}
const handleChangeStatusOfSpinWheelModal =async()=>{
  let wheelStatus= false;
  if(spinWheelData.status == true){
    wheelStatus = false
  }else{
    wheelStatus = true
  }
  const pauseObj ={
    docId: spinWheelData.id,
    state: wheelStatus
  }

  try{
  const response = await SpinWheelService.changeStatusOfSpinWheel(pauseObj)
  console.log(response.data)
  setIsPauseWheelModal(false);
  window.location.reload()
  }catch(error){

  }
}
const userObj = JSON.parse(localStorage.getItem("userData"));
  const userRole = userObj?.user?.role;
const handleEditWheel = async()=>{

  try{
    const response = await SpinWheelService.getSpinWheelInfoById(spinWheelData.id);
    const fetchData = response.data;
    if(userRole == "Admin"){
      navigate(`/admin/spin-wheel-editor`, {state: {spinWheelData: fetchData, docId: spinWheelData.id}})
        }else if(userRole == "CMO"){
          navigate(`/cmo/spin-wheel-editor`,  {state: {spinWheelData: fetchData, docId: spinWheelData.id}})

        }
  }catch(error){
    console.log(error.response.data)
  }

}
  return (
    <>

 <div  className="border border-gray-400 grid grid-cols-6  items-center bg-white w-auto h-40 rounded-md px-8 cursor-pointer">

 <div className="border-r border-gray-400 p-3 ">
   <h1 className="text-lg  text-[#525252]">Wheel Title</h1>
   <h1 className="text-xl font-medium">{spinWheelData.wheelTitle} </h1>
   <h1 className="text-lg font-medium">
     Status:{" "}
     <span className="text-base font-normal">
       {" "}
       {spinWheelData.status === true ? "Live" : "Paused"}
     </span>
   </h1>
 </div>

 <div className="border-r text-center border-gray-400 p-3 ">
   <h1 className="text-lg  text-[#525252] ">Total Spins</h1>
   <h1 className="text-xl font-medium pb-6">{spinWheelData.totalSpins}</h1>
 </div>
 <div className="border-r text-center border-gray-400 p-3 ">
   <h1 className="text-lg  text-[#525252]">Gift Won</h1>
   <h1 className="text-xl font-medium">{spinWheelData.giftWon}</h1>
   <button onClick={handleSpinWheelWonExcel}  className="text-customGreen">Download</button>
 </div>
 <div className="border-r text-center border-gray-400 p-3">
   <h1 className="text-lg  text-[#525252]">Gift Lose</h1>
   <h1 className="text-xl font-medium">{spinWheelData.giftLost}</h1>
   <button onClick={handleSpinWheelLostExcel}   className="text-customGreen">Download</button>
 </div>

 <div className="flex flex-col px-3 gap-4">

     <div className="flex  gap-6 text-white w-full">
         <button
         onClick={handleEditWheel}
         className="bg-customGreen  text-xl font-medium rounded-lg whitespace-nowrap p-2">Edit Wheel</button>
         <button onClick={handleWheelPause}
         className={`${
          spinWheelData.status ? "bg-[#E19211]" : "bg-blue-500"
        } text-xl font-medium rounded-lg whitespace-nowrap p-2`}
          // className={`${spinWheelData.status == true? "bg-[#E19211]":"bg-customGreen"}text-xl font-medium text-black rounded-lg whitespace-nowrap p-2`}
          >{spinWheelData.status? "Pause Wheel" :"Start Wheel"}</button>
         <button onClick={handleWheelReset} className="bg-red-500 text-xl font-medium rounded-lg whitespace-nowrap p-2  ">Reset Wheel</button>



     </div>
 <div  className="flex gap-1 rounded-lg shadow-lg px-3  w-full h-8 border items-center border-gray-400 ">
   <p   className="w-full text-sky-400-700 text-sm  truncate">{textToCopy}</p>
   <CopyToClipboard text={textToCopy} onCopy={handleCopy}>
        <button className="w-5">
          {copied ? (
            <img src={icon.tickIcon} alt="Copied" />
          ) : (
            <img src={icon.clipboardCopyIcon} alt="Copy to clipboard" />
          )}
        </button>
      </CopyToClipboard>
 </div>
 </div>

</div>
<Modal
    isOpen={isPauseWheelModal}
    onRequestClose={handleClosePauseWheelModal}
    contentLabel ="Pause Wheel"
    style={customStyles}
    >

<button
          onClick={handleClosePauseWheelModal}
          className="absolute top-2 right-2 text-2xl text-gray-700"
        >
          &times;
        </button>

        <h2 className="text-xl text-center font-normal mb-4 w-full">Are you sure to change the  status of <br /> the Spin Wheel ?</h2>
<div className="flex justify-between px-20 mt-10">
    <button
          onClick={handleClosePauseWheelModal}

              className="bg-gray-400 text-white  rounded-md w-20 font-normal"

    >No</button>
    <button
              className="bg-customGreen text-white  w-20 rounded-md  font-normal"
    onClick={handleChangeStatusOfSpinWheelModal}
    >Yes</button>
</div>
    </Modal>


    <Modal
    isOpen={isResetWheelModal}
    onRequestClose={handleCloseResetWheelModal}
    contentLabel ="Pause Wheel"
    style={customStyles}
    >

<button
          onClick={handleCloseResetWheelModal}
          className="absolute top-2 right-2 text-2xl text-gray-700"
        >
          &times;
        </button>

        <h2 className="text-xl text-center font-normal mb-4">Are you sure to reset the Spin Wheel ?</h2>
<div className="flex justify-between px-20 mt-10">
    <button
          onClick={handleCloseResetWheelModal}

              className="bg-gray-400 text-white  rounded-md w-20 font-normal"

    >No</button>
    <button
              className="bg-customGreen text-white  w-20 rounded-md  font-normal"
    onClick={handleResetSpinWheelModal}
    >Yes</button>
</div>
    </Modal>
    </>

  );
};

export default SpinWheelDetail;
